import { useEffect, useRef, useState, useCallback } from 'react';

const cache = new Map();
const TTL = 3 * 60 * 1000;

export const useAnalyticsQuery = (key, fetcher, deps = []) => {
  const [data, setData] = useState(() => {
    const c = cache.get(key);
    return c && Date.now() - c.ts < TTL ? c.data : null;
  });
  const [loading, setLoading] = useState(!data);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const run = useCallback(async () => {
    setError(null);
    try {
      if (abortRef.current) abortRef.current.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      const result = await fetcher({ signal: controller.signal });
      cache.set(key, { data: result, ts: Date.now() });
      setData(result);
    } catch (e) {
      if (e.name !== 'AbortError') setError(e.message || 'Bir sorun oluştu');
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, ...deps]);

  useEffect(() => {
    const c = cache.get(key);
    if (c && Date.now() - c.ts < TTL) {
      setData(c.data); setLoading(false);
    } else {
      setLoading(true);
    }
    run();
    return () => { if (abortRef.current) abortRef.current.abort(); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, ...deps]);

  const invalidate = useCallback(() => { cache.delete(key); run(); }, [key, run]);

  return { data, loading, error, refresh: run, invalidate };
};
